import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import HonorarRechner from "@/components/HonorarRechner";

/**
 * /rechner — öffentliche, login-freie Kalkulator-Seite.
 * Nutzbar als deep-link für End-Kunden ("Was darf mein Gutachten kosten?")
 * und für Gutachter-Partner zur Selbstkalkulation. Kein Branding, keine
 * Sticky-CTAs — schnelle, ehrliche Antwort.
 */
export default function RechnerPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="rechner-page">
      <header className="border-b border-zinc-200 bg-white/85 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="rechner-logo">
            <img src="/easy-gutachter-logo.png" alt="Easy Gutachter" className="h-12 w-auto select-none" draggable={false} />
          </Link>
          <Link to="/preise">
            <Button size="sm" variant="ghost" data-testid="rechner-to-pricing">
              Pakete & Pricing
            </Button>
          </Link>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-12 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900 mb-6">
          <ArrowLeft className="h-4 w-4" /> Zurück
        </Link>

        <div className="max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-cyan-700">Honorar-Rechner</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-2">
            Was kostet ein Kfz-Gutachten?
          </h1>
          <p className="text-zinc-600 mt-4 text-lg">
            Schnelle Einschätzung nach <strong>BVSK-Honorartabelle 2024</strong> — der gängige
            Branchenstandard. Bei unverschuldetem Unfall trägt die gegnerische
            Haftpflichtversicherung die Kosten zu 100 %.
          </p>
        </div>

        <div className="mt-10">
          <HonorarRechner />
        </div>

        <div className="mt-10 grid sm:grid-cols-3 gap-4 text-sm">
          <div className="rounded-2xl border border-zinc-200 p-4">
            <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-zinc-500">Bei unverschuldetem Unfall</div>
            <div className="font-display text-2xl font-bold mt-1">100 %</div>
            <div className="text-zinc-600 mt-1">erstattet die gegnerische Haftpflicht — § 249 BGB.</div>
          </div>
          <div className="rounded-2xl border border-zinc-200 p-4">
            <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-zinc-500">Bagatell-Grenze</div>
            <div className="font-display text-2xl font-bold mt-1">~ 1.000 €</div>
            <div className="text-zinc-600 mt-1">ab dieser Schadenhöhe lohnt sich ein vollständiges Gutachten.</div>
          </div>
          <div className="rounded-2xl border border-zinc-200 p-4">
            <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-zinc-500">Freie Wahl garantiert</div>
            <div className="font-display text-2xl font-bold mt-1">BGH</div>
            <div className="text-zinc-600 mt-1">Du musst nicht den Versicherungs-Gutachter nehmen.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
